import moment from 'moment'
import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {useMember} from '../../hook'

const MembersByItemList = ({
  loading,
  itemId,
  isMemberShipProduct,
}: {
  loading: boolean
  itemId: string
  isMemberShipProduct: boolean
}) => {
  const intl = useIntl()
  const {
    listPurchase: list,
    listPurchaseFilter: listFilter,
    listPurchaseFilterSet: listFilterSet,
  } = useMember()

  const columns = [
    {
      key: 'fullname',
      width: '150',
      dataIndex: 'fullName',
      title: intl.formatMessage({id: 'MEMBER.LIST.NAME'}),
    },
    {
      key: 'status',
      dataIndex: 'status',
      title: intl.formatMessage({id: 'MEMBER.LIST.STATUS'}),
      // status: true,
      render: (text: string) => {
        switch (text.toString()) {
          case '1':
            return (
              <span className='badge badge-light-success'>
                {intl.formatMessage({id: 'GLOBAL.ACTIVE'})}
              </span>
            )
          case '2':
            return (
              <span className='badge badge-light-warning text-black-50'>
                {intl.formatMessage({id: 'GLOBAL.INACTIVE'})}
              </span>
            )
          case '3':
            return <span className='badge badge-light-primary'>Preactive</span>
          case '4':
            return <span className='badge badge-light-danger'>Cancelled</span>
          case '5':
            return <span className='badge badge-light-info'>Expired</span>
          default:
            return (
              <span className='badge badge-light-warning text-black-50'>
                {intl.formatMessage({id: 'GLOBAL.PREACTIVE'})}
              </span>
            )
        }
      },
    },
    {
      key: 'startDate',
      dataIndex: 'startDate',
      title: 'Start Date',
      render: (text: string) => (
        <>{!isMemberShipProduct ? '-' : moment.utc(text).format('DD/MM/YYYY HH:mm')}</>
      ),
    },
    {
      key: 'endDate',
      dataIndex: 'endDate',
      title: 'End Date',
      render: (text: string) => (
        <>{!isMemberShipProduct ? '-' : moment.utc(text).format('DD/MM/YYYY HH:mm')}</>
      ),
    },
    {
      key: 'action',
      dataIndex: 'memberId',
      title: intl.formatMessage({id: 'MEMBER.LIST.ACTION'}),
      render: (memberId: string, data: any) => {
        if (!isMemberShipProduct) {
          return (
            <a href={`/members/${memberId}`}>{intl.formatMessage({id: 'MEMBER.LIST.DETAIL'})}</a>
          )
        } else {
          return (
            <a href={`/members/product/${data.id}/${memberId}`}>
              {intl.formatMessage({id: 'MEMBER.LIST.DETAIL'})}
            </a>
          )
        }
      },
    },
  ]

  return (
    <Table
      loading={loading}
      dataSource={list.dataList}
      columns={columns}
      tableName={'membersPurchasedProduct'}
      pagination={{
        current: list.paging.currentPageNumber,
        pageSize: list.paging.pageSize,
        total: list.paging.totalCount,
        onChange: (page: any) => {
          const {pageSize, current} = page
          const currentPage = pageSize !== listFilter.paging.pageSize ? 1 : current

          listFilterSet({
            ...listFilter,
            paging: {
              ...listFilter.paging,
              pageSize,
              currentPageNumber: currentPage,
            },
          })
        },
      }}
    />
  )
}

export default MembersByItemList
